import { createLliamHelper } from '@wayfinder/lliam-api-contract/client';
import * as Request from '../request';
import * as Config from '../config';

/*
 * Adapter returning a legacy-shaped client `{ getDerivedPolicyForToken }` whose
 * response matches the old swagger shape `{ statusCode, body: { data, meta } }`.
 * This lets `Request.makeRequest` (which inspects `response.statusCode` and
 * extracts `body.data`) continue to work unchanged.
 */
const lliamClient = async (stage = Config.getStage()) => {
    const accessToken = await Config.getAccessToken();
    const helper = createLliamHelper({ token: accessToken, stage });
    return {
        getDerivedPolicyForToken: async () => {
            const { status, body } = await helper.getDerivedPolicyForToken();
            return { statusCode: status, body };
        },
    };
};

const getDerivedPolicyForTokenRequest = Request.makeRequest(lliamClient, 'getDerivedPolicyForToken');

const Lliam = { getDerivedPolicyForToken: () => getDerivedPolicyForTokenRequest() };

export { Lliam };
